import DeleteAPIAccessConfirmPopup from "./DeleteAPIAccessConfirmPopup";

export default DeleteAPIAccessConfirmPopup;